/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { Dialog, CardContent, Card } from "@mui/material";
import { useSnackbar } from "hooks/useSnackbar";
import { LinkContext } from "cms/links/link-selector/context";
import { LinkSelectContext } from "cms/links/link-selector/context/select";
import { LinkSelectHeader } from "cms/links/link-selector/dialog-select/panels/link-select-header";
import { LinkDialogBottomActions } from "cms/links/link-selector/dialog-select/actions/link-dialog-bottom-actions";
import { LinkDialogSelectPanel } from "cms/links/link-selector/dialog-select/select";

const LinkSelectDialog = () => {
    
    const {
        open,
        handleClose,
        selectedLink,
        setSelectedLink,
        MODES,
        setMode,
        needsRefresh,
        setNeedsRefresh
    } = useContext(LinkContext);
    
    const [links, setLinks] = useState();
    
    const searchFunction = SimpliCityAdminSDK.link.search;
    const scrollableHeight = "480px"; // '450px'
    const { showSnackbar } = useSnackbar();
    
    const onSelectLink = (e, link) => {
        e.stopPropagation();
        setSelectedLink(link);
    };

    const linkSelectCtx = {
        links,
        setLinks,
        searchFunction,
        scrollableHeight,
        onSelectLink,
        selectedLink, // from edit context
        setSelectedLink, // from edit context
        showSnackbar,
        MODES,
        setMode,
        needsRefresh,
        setNeedsRefresh,
    };

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth='lg'
                className='simplicity-link-selector-overlay select'
            >
                <LinkSelectContext.Provider value={linkSelectCtx}>
                    <Card elevation={0} className='simplicity-link-selector-window'>
                        <CardContent sx={{ flex: "1 0 auto", height: "100%", padding: 0 }}>
                            
                            <LinkSelectHeader />
                            
                            <div className='simplicity-link-selector-window-content'>
                                <div className='simplicity-link-selector-window-active'>
                                    
                                    <LinkDialogSelectPanel />
                                    
                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    <LinkDialogBottomActions />
                    
                </LinkSelectContext.Provider>
            </Dialog>
        </Fragment>
    );
};

export { LinkSelectDialog };
